export default function getPaymentGateway(
  state = { error: null, success: null, processing: "" },
  action
) {
  switch (action.type) {

    case 'FETCH_PAYMENT_GATEWAY_SUCCESS':
      return {...state, ...{success: action.success}};
    case 'FETCH_PAYMENT_GATEWAY_ERROR':
      return {...state, ...{error: action.error}};
    case 'FETCH_PAYMENT_GATEWAY_PROCESSING':
      return {...state, ...{processing: action.processing}};
    default:
      return state;
  }
}
